import * as _ from "lodash";
export default class ColorStack {
    private _colors: string[];
    private _available!: string[];

    constructor(colors: string[]) {
        this._colors = _.clone(colors);
        this.reset();
    }

    public reset() {
        this._available = _.clone(this._colors);
    }

    public acquire(): string {
        if (!this._available.length) {
            this.reset();
        }

        return this._available.shift()!;
    }

    public release(color: string) {
        this._available.unshift(color);
    }
}
